import { Box } from '@cdl/heartbeat-react';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Loading } from '../../../shared/components/Loading';
import { useTypedDispatch } from '../../../store/useTypedDispatch';
import { loadNextEcg } from '../thunks/load-next-ecg.thunk';

type ListState = 'loading' | 'empty' | 'failed';

export const EcgList: React.FC = () => {
  const navigate = useNavigate();
  const [listState, setListState] = useState<ListState>('loading');
  const dispatch = useTypedDispatch();

  useEffect(() => {
    let componentActive = true;
    (async () => {
      const result = await dispatch(loadNextEcg());
      if (!componentActive) {
        return;
      }
      switch (result.type) {
        case 'success':
          return await navigate(`/${result.ecgId}`);
        case 'empty':
          return setListState('empty');
        case 'error':
          return setListState('failed');
      }
    })();

    return () => {
      componentActive = false;
    };
  }, [navigate, dispatch]);

  switch (listState) {
    case 'loading':
      return <Loading>Loading ecg list</Loading>;
    case 'empty':
      return <Box m='m'>All done !</Box>;
    case 'failed':
      return <Box m='m'>Something went wrong while loading the ecg list</Box>;
  }
};
